"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInputFieldTypes = void 0;
const types_1 = require("../../types/types");
const is_product_1 = require("../is-product/is-product");
// This method is fairly straightforward compared to the business logic it represents,
// splitting it into subfunctions would only make it more complicated.
function getInputFieldTypes(products, only) {
    const result = new Set();
    if (products.some(is_product_1.isDirectMarketing) && only !== 'bands') {
        result.add(types_1.InputFieldType.PRODUCTION);
        if (products.some(is_product_1.isFCR) && !products.some(is_product_1.isFlexPlus)) {
            result.add(types_1.InputFieldType.FCR);
        }
        if (products.some(is_product_1.isFlexPlus)) {
            result.add(types_1.InputFieldType.FLEX_PLUS_UPPER_LIMIT);
            result.add(types_1.InputFieldType.FLEX_PLUS_LOWER_LIMIT);
        }
        else {
            if (products.some(is_product_1.isAFrrMinus) || products.some(is_product_1.isAFrrPlus)) {
                result.add(types_1.InputFieldType.AFRR_UPPER_LIMIT);
                result.add(types_1.InputFieldType.AFRR_LOWER_LIMIT);
            }
            if (products.some(is_product_1.isMFrrMinus) || products.some(is_product_1.isMFrrPlus)) {
                result.add(types_1.InputFieldType.MFRR_UPPER_LIMIT);
                result.add(types_1.InputFieldType.MFRR_LOWER_LIMIT);
            }
        }
        if (only === 'limits')
            return [...result];
    }
    if (products.some(is_product_1.isFCR)) {
        result.add(types_1.InputFieldType.FCR);
    }
    if (products.some(is_product_1.isAFrrMinus)) {
        result.add(types_1.InputFieldType.AFRR_NEGATIVE);
    }
    if (products.some(is_product_1.isAFrrPlus)) {
        result.add(types_1.InputFieldType.AFRR_POSITIVE);
    }
    if (products.some(is_product_1.isMFrrMinus)) {
        result.add(types_1.InputFieldType.MFRR_NEGATIVE);
    }
    if (products.some(is_product_1.isMFrrPlus)) {
        result.add(types_1.InputFieldType.MFRR_POSITIVE);
    }
    return [...result];
}
exports.getInputFieldTypes = getInputFieldTypes;
